module.exports = __webpack_public_path__ + "img/curved9.b94cc693.jpg";